import React from 'react';
import styles from '../PostPurchaseStep.scss';

export function SetupVideoIcon() {
  return (
    <div className={styles.postPurchaseSetupIcon} aria-hidden="true">
      <svg width="74" height="74" viewBox="0 0 74 74" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14.7 20.6 50.5 14l7.1 38.8-35.8 6.6-7.1-38.8Z" fill="#116DFF" />
        <path d="M22.3 18.7 58.5 23l-4.8 39.2-36.2-4.4 4.8-39.1Z" fill="#28BF9A" />
        <path d="M19 11h39v45H19V11Z" fill="#D6E6FE" />
        <path d="M25 17h27v31H25V17Z" fill="#FFFFFF" />
        <path d="m25 48 10.9-11.3 6.3 6.2 4.6-5.2L52 43v5H25Z" fill="#CFE5FF" />
        <path d="M38.8 42.1 35 20l13.2 17.9-5.6.9 4.1 7.2-3.6 2-4.3-5.9Z" fill="#FFC0B8" />
        <path d="m55.4 6.3-1.8 11.1M63.8 15.1l-8.4 7M45.8 5.8l1.1 9.5" stroke="#000624" strokeWidth="1.3" />
      </svg>
    </div>
  );
}

export function CelebrationIcon() {
  return (
    <div className={styles.postPurchaseCelebration} aria-hidden="true">
      <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="m31.52 53.048 1.415 1.414-4.101 4.101-1.415-1.414 4.102-4.101ZM30 11.63c10.146 0 18.37 8.224 18.37 18.37 0 10.145-8.224 18.37-18.37 18.37-10.145 0-18.37-8.225-18.37-18.37 0-10.146 8.225-18.37 18.37-18.37ZM5.424 33.312l1.414 1.415-4.101 4.1-1.414-1.413 4.101-4.102ZM55.52 29.09a1.69 1.69 0 1 1 0 3.38 1.69 1.69 0 0 1 0-3.38ZM28.35 1.882l4.1 4.101-1.413 1.414-4.102-4.101 1.415-1.414Z"
          fill="#312E81"
        />
        <path d="m27.79 38.96-7.42-7.42 2.12-2.13 5.3 5.31 10.98-10.99 2.12 2.13-13.1 13.1Z" fill="#fff" />
        <path
          d="m54.574 39.187 4.101 4.101-1.414 1.414-4.101-4.101 1.414-1.414ZM56.27 10.71l-1.33 4.96-3.63-3.63 4.96-1.33ZM10.3 6.88l4.96 1.33-3.63 3.63-1.33-4.96Z"
          fill="#28BF9A"
        />
        <path
          d="M43.1 51.19a1.69 1.69 0 1 1 0 3.38 1.69 1.69 0 0 1 0-3.38ZM6.8 45.63l4.96 1.32-3.63 3.64-1.33-4.96ZM7 16.31a1.69 1.69 0 1 1 0 3.38 1.69 1.69 0 0 1 0-3.38ZM41.25 1.99a1.69 1.69 0 1 1 0 3.38 1.69 1.69 0 0 1 0-3.38Z"
          fill="#FFD527"
        />
      </svg>
    </div>
  );
}

